<script>
  /**
   * Indicates whether a backdrop is displayed.
   * @type {boolean}
   * @default false
   */
  export let backdrop = false;

  /**
   * Specifies the color of the backdrop.
   * @type {string}
   * @default 'rgba(255, 255, 255, .6)'
   */
  export let backdropColor = 'rgba(255, 255, 255, .6)';

  /**
   * Controls the visibility of the loader.
   * @type {boolean}
   * @default false
   */
  export let show = false;

  /**
   * Determines whether the loader should render inline.
   * @type {boolean}
   * @default false
   */
  export let inline = false;

  /**
   * Defines the size of the loader. Acceptable values are `small`, `large`, `xlarge`.
   * @type {string}
   * @default 'medium'
   */
  export let size = 'medium';

  /**
   * When true, positions the loader and backdrop to cover the full viewport.
   * @type {boolean}
   * @default false
   */
  export let fullscreen = false;
</script>

{#if show}
  {#if backdrop}
    <div class="loader-backdrop" class:fullscreen style="background-color: {backdropColor};" />
  {/if}
  <div class="loader {size}" class:inline class:fullscreen>
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
  </div>
{/if}

<style lang="scss" src="./loader.scss"></style>
